module.exports = __webpack_public_path__ + "static/img/icon_send_colorful.e5ef1ab5.png";